// Convert a public video / PDF URL to a safe embed URL.
// Supports: Loom, YouTube, Vimeo, raw mp4, PDFs (rendered in <iframe> via browser viewer).
export function toEmbedUrl(rawUrl) {
  if (!rawUrl) return null;
  const url = rawUrl.trim();

  // Loom share → embed
  const loomMatch = url.match(/loom\.com\/share\/([a-zA-Z0-9]+)/);
  if (loomMatch) return `https://www.loom.com/embed/${loomMatch[1]}`;

  // YouTube — handle youtu.be/<id>, watch?v=<id>, and shorts/<id>
  const ytShort = url.match(/youtu\.be\/([a-zA-Z0-9_-]{6,})/);
  if (ytShort) return `https://www.youtube.com/embed/${ytShort[1]}`;
  const ytWatch = url.match(/[?&]v=([a-zA-Z0-9_-]{6,})/);
  if (ytWatch) return `https://www.youtube.com/embed/${ytWatch[1]}`;
  const ytShorts = url.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{6,})/);
  if (ytShorts) return `https://www.youtube.com/embed/${ytShorts[1]}`;

  // Vimeo
  const vim = url.match(/vimeo\.com\/(\d+)/);
  if (vim) return `https://player.vimeo.com/video/${vim[1]}`;

  // Raw video file or PDF — browser can render directly
  if (/\.(mp4|webm|ogg|pdf)(\?|$)/i.test(url)) return url;

  // Already an embed URL (loom/youtube/vimeo embed paths)
  if (/\/(embed|player)\//.test(url)) return url;

  return null;
}

// Friendly label for what we detected
export function detectMediaKind(rawUrl) {
  if (!rawUrl) return null;
  const url = rawUrl.trim().toLowerCase();
  if (url.includes('loom.com')) return 'Loom';
  if (url.includes('youtube.com') || url.includes('youtu.be')) return 'YouTube';
  if (url.includes('vimeo.com')) return 'Vimeo';
  if (url.endsWith('.pdf')) return 'PDF';
  if (/\.(mp4|webm|ogg)$/i.test(url)) return 'Video file';
  return 'Link';
}
